import React, { Component } from 'react';
import { observer } from 'mobx-react';
import OtherSettingsStore from 'Stores/otherSettingsStore';
import 'Styles/otherSettings/otherSettings.scss';
import LogsSubdirectoriesModal from "Components/OtherSettings/LogsSubdirectoriesModal";
import { ShowModal, ShowAlert } from 'Utils/CommonFunctions';
import RestrictionSelectModal from "Components/OtherSettings/restrictionSelectModal";
import LoadView from "Components/Common/loadView";
import LoadingIndicator from "Components/Common/LoadingIndicator";
import NamedBlock from "Components/Common/NamedBlock";
import { Navigate } from 'react-router-dom';
import AppStore from 'Stores/AppStore';
import IntegrationSettingsStore from 'Stores/integrationSettingsStore';
import ProductMode from "Utils/ProductMode";
import TextInputSetting from 'Components/Common/Settings/TextInputSetting';
import DescriptionTextSetting from 'Components/Common/Settings/DescriptionTextSetting';
import SwitcherSetting from 'Components/Common/Settings/SwitcherSetting';
import ActionSetting from 'Components/Common/Settings/ActionSetting';
import TextSetting from 'Components/Common/Settings/TextSetting';
import ComboBoxSetting from 'Components/Common/Settings/ComboBoxSetting';
import SettingsBlock from 'Components/Common/Settings/SettingsBlock';
import TransitionBlocker from 'Components/Common/TransitionBlocker';
import NumericSetting from 'Components/Common/Settings/NumericSetting';
import ProtocolRecordsStore from 'Stores/ProtocolRecords/protocolRecordsStore';

class OtherSettings extends Component {
    componentDidMount() {
        AppStore.OnMainComponentMount('Системные настройки', 'otherSettings');

        OtherSettingsStore.GetSettings();
    }

    ShowLogsSubdirectoriesModal() {
        OtherSettingsStore.GetClientLogsSubDirectoriesList();

        ShowModal({
            canBeClosed: true,
            header: 'Выгрузка клиентских логов',
            children: <LogsSubdirectoriesModal />,
            className: 'LogsSubdirectoriesModal'
        });
    }

    ShowRestrictionQuestionModel() {
        if (!OtherSettingsStore.restrictionsUpdateProgress.inProcess) {
            ShowModal({
                header: 'Пересинхронизация файлов',
                canBeClosed: true,
                className: 'sync-synced-question-modal',
                children: 'Данная операция запустит процесс удаления недоступных файлов и загрузки доступных. Процесс обновления состояний файлов по документам может занять продолжительное время и активно использует ресурсы сервера. Рекомендуется выполнять её в нерабочее время. Хотите продолжить?',
                buttons: [{
                    content: 'Отменить',
                    closer: true
                }, {
                    content: 'Продолжить',
                    closer: false,
                    onClick: (close) => {
                        close();
                        this.ShowRestrictionSelectModal();
                    }
                }]
            });
        }
    }

    ShowRestrictionSelectModal() {
        ShowModal({
            canBeClosed: true,
            header: 'Запрещенные грифы доступа',
            children: (<RestrictionSelectModal />),
            className: 'restriction-select-modal',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Запустить',
                className: `blue-button ${(AppStore.dmsisIsWork == false || OtherSettingsStore.restrictionsUpdateProgress.inProcess) ? "disabled" : ""}`,
                closer: true,
                onClick: () => OtherSettingsStore.SaveRestrictions()
            }]
        });
    }

    ShowSyncSyncedQuestionModal() {
        ShowModal({
            header: 'Синхронизация пользователей',
            canBeClosed: true,
            className: 'sync-synced-question-modal',
            children: 'Данная операция запустит процесс повторной синхронизации всех активированных пользователей. Процесс загрузки и обновления данных может занять продолжительное время и активно использует ресурсы сервера. Во время выполнения синхронизации профили активированных пользователей будут заблокированы для редактирования. Рекомендуется выполнять её в нерабочее время. Хотите продолжить?',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Продолжить',
                closer: true,
                onClick: () => OtherSettingsStore.SyncSyncedUsers()
            }]
        })
    }

    ShowStopSyncSyncedModal() {
        ShowModal({
            canBeClosed: true,
            header: 'Синхронизация пользователей',
            className: 'stop-sync-synced-process-modal',
            children: 'Очередь пользователей будет очищена, а синхронизация текущего пользователя будет выполнена. Вы действительно хотите прервать синхронизацию пользователей?',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Прервать',
                onClick: () => OtherSettingsStore.StopSyncSyncedProcess(),
                closer: true
            }]
        });
    }

    render() {
        if (this.props.migrationInProcess) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }

        let selectedRestrictionsString =
            OtherSettingsStore.selectedRestrictionsIds.length == 0
                ? 'Не выбрано'
                : OtherSettingsStore.selectedRestrictionsIds
                    .map(id => {
                        let restriction = OtherSettingsStore.restrictions.find(it => it.id == id);
                        return `${restriction.value}${restriction.deleted ? " (логически удален)" : ''}`;
                    })
                    .join(', ');

        let syncSyncedProcess = '';

        var syncStarted =
            OtherSettingsStore.usersReloadState != null
            &&
            OtherSettingsStore.usersReloadState.inProcess
            ;
        var syncInfoAvailable =
            syncStarted
            &&
            OtherSettingsStore.usersReloadState.currentProccessedUserLid != null
            ;

        if (syncStarted) {

            let usersReloadState = OtherSettingsStore.usersReloadState;
            let usersReloadStateProgress = usersReloadState.progress;

            syncSyncedProcess = (
                <NamedBlock
                    key="sync-synced-users-process"
                    title='Выполняется синхронизация пользователей'
                    className='common-info-named-block'>
                    <div className='total-sync-info'>
                        {

                            (syncInfoAvailable)
                                ?
                                <div className='total-sync-info-title'>
                                    <div>Синхронизировано пользователей: {usersReloadState.usersLoadedCount} из {usersReloadState.usersQueueInitialCount}</div>
                                    <div>Всего синхронизировано {usersReloadStateProgress.loaded} из {usersReloadStateProgress.total} РК/РКПД{AppStore.meetingSwitcherEnabled ? ", совещаний" : null}</div>
                                </div>
                                : ''

                        }
                        <LoadingIndicator
                            loaded={usersReloadStateProgress.loaded}
                            total={usersReloadStateProgress.total}
                            runner={usersReloadStateProgress.total === 0} />
                    </div>
                </NamedBlock>
            )
        }

        var settingsFilesForCheckVisibility = [
            <ActionSetting
                id='files-restrictions'
                key="files-restrictions"
                title='Запретить передачу файлов с грифом доступа:'
                disabled={OtherSettingsStore.restrictionsUpdateProgress.inProcess || IntegrationSettingsStore.dmsis.hasError}
                value='Выбрать'
                onClick={() => this.ShowRestrictionQuestionModel()} />
            ,
            <DescriptionTextSetting
                key="files-restrictions-select"
                text={selectedRestrictionsString} />
            ,
            (OtherSettingsStore.restrictionsUpdateProgress.inProcess
                ? (
                    <NamedBlock
                        key="files-restrictions-process"
                        title='Применение настроек для всех файлов'
                        className='common-info-named-block'>
                        <div className='total-sync-info'>
                            <div className='total-sync-info-title'>
                                <div>
                                    {`Синхронизировано ${OtherSettingsStore.restrictionsUpdateProgress.isMeeting ? "совещаний" : "документов"}: ${OtherSettingsStore.restrictionsUpdateProgress.progressCurrent} из ${OtherSettingsStore.restrictionsUpdateProgress.progressTotal}`}
                                </div>
                            </div>
                            <LoadingIndicator loaded={OtherSettingsStore.restrictionsUpdateProgress.progressCurrent}
                                total={OtherSettingsStore.restrictionsUpdateProgress.progressTotal}
                                runner={OtherSettingsStore.restrictionsUpdateProgress.progressTotal === 0} />
                        </div>
                    </NamedBlock>
                )
                : "")
            ,
            <ActionSetting
                id='max-file-size'
                key='max-file-size'
                title='Не загружать файлы больше (Мб):'
                disabled={OtherSettingsStore.bigFileUpdateProgress.inProcess || IntegrationSettingsStore.dmsis.hasError}
                value='Выбрать'
                onClick={() => OtherSettingsStore.ShowSetMaxFileSizeModal()} />
            ,
            <DescriptionTextSetting
                key="max-file-size-value"
                text={`Установленное ограничение: ${OtherSettingsStore.maxFileSize} Мб`} />
            ,
            (OtherSettingsStore.bigFileUpdateProgress.inProcess
                ? (
                    <NamedBlock
                        key="max-file-size-process"
                        title='Применение настроек для всех файлов'
                        className='common-info-named-block'>
                        <div className='total-sync-info'>
                            <div className='total-sync-info-title'>
                                <div>
                                    {`Синхронизировано ${OtherSettingsStore.bigFileUpdateProgress.isMeeting ? "совещаний" : "документов"}: ${OtherSettingsStore.bigFileUpdateProgress.progressCurrent} из ${OtherSettingsStore.bigFileUpdateProgress.progressTotal}`}
                                </div>
                            </div>
                            <LoadingIndicator loaded={OtherSettingsStore.bigFileUpdateProgress.progressCurrent}
                                total={OtherSettingsStore.bigFileUpdateProgress.progressTotal}
                                runner={OtherSettingsStore.bigFileUpdateProgress.progressTotal === 0} />
                        </div>
                    </NamedBlock>
                )
                : "")
        ];
        var settingsUsersForCheckVisibility = [
            <ComboBoxSetting
                id="silent-clean-period"
                key="silent-clean-period"
                title='Логически удалять бездействующего пользователя через:'
                values={OtherSettingsStore.silentCleanPeriods}
                selectedItem={OtherSettingsStore.currentLocalSettings.silentCleanPeriod}
                onSelectedItemChanged={key => OtherSettingsStore.SetSelectedSilentCleanPeriod(key)} />
            ,
            <SwitcherSetting
                key='restore-logical-deleted-users'
                title='Автоматически восстанавливать логически удаленного пользователя:'
                value={OtherSettingsStore.currentLocalSettings.restoreLogicalDeletedUsers}
                onChanged={(value) => OtherSettingsStore.SetRestoreLogicalDeletedUsers(value)} />
            ,
            <ActionSetting
                id='sync-synced-users'
                key='sync-synced-users'
                title='Повторить синхронизацию активированных пользователей'
                helperText='После запуска данной операции к каждому активированному пользователю поочередно будет применена операция "Повторить синхронизацию".'
                {...((OtherSettingsStore.usersReloadState != null && OtherSettingsStore.usersReloadState.inProcess)
                    ? {
                        value: 'Прервать',
                        disabled: OtherSettingsStore.usersReloadState.currentStateOfUsersQueue.length < 2,
                        onClick: () => this.ShowStopSyncSyncedModal()
                    }
                    : {
                        value: 'Запустить',
                        disabled: (OtherSettingsStore.syncSyncedStartResponseWait || IntegrationSettingsStore.dmsis.hasError),
                        onClick: () => this.ShowSyncSyncedQuestionModal()
                    })} />
            ,
            syncSyncedProcess
        ];
        var settingsProtocolForCheckVisibility = [
            <SwitcherSetting
                key='showTechInfo'
                title='Показывать техническую информацию:'
                value={OtherSettingsStore.currentLocalSettings.showTechInfo}
                onChanged={(value) => OtherSettingsStore.SetShowTechInfo(value)} />
            ,
            <TextSetting
                key="protocolArchiveDirectory"
                title='Директория хранения архива протокола:'
                value={OtherSettingsStore.protocolArchiveDirectory}
                buttonValue='Выгрузить последний'
                disabled={ProtocolRecordsStore.state.inProcess || (ProtocolRecordsStore.state.hasArchive === false)}
                onClick={() => ProtocolRecordsStore.DownloadLastProtocolArchive()} />
            ,
            <SwitcherSetting
                key="protocolArchivationEnabled"
                title='Запускать архивацию:'
                value={OtherSettingsStore.currentLocalSettings.protocolArchivationEnabled}
                onChanged={(value) => OtherSettingsStore.SetProtocolArchivationEnabled(value)} />
            ,
            OtherSettingsStore.currentLocalSettings.protocolArchivationEnabled ? null :
                <NumericSetting
                    id="protocolArchivePeriod"
                    key="protocolArchivePeriod"
                    title='Запускать архивацию раз в (дней):'
                    minValue={10}
                    maxValue={100}
                    value={OtherSettingsStore.currentLocalSettings.protocolArchivePeriod}
                    valueChanged={(val) => OtherSettingsStore.SetProtocolArchivePeriod(val)} />
            ,
            OtherSettingsStore.currentLocalSettings.protocolArchivationEnabled ? null :
                <NumericSetting
                    id="settings-protocol-savePeriod"
                    key="settings-protocol-savePeriod"
                    title='Не архивировать последние (дней):'
                    minValue={1}
                    maxValue={180}
                    value={OtherSettingsStore.currentLocalSettings.protocolSavePeriod}
                    valueChanged={(val) => OtherSettingsStore.SetProtocolSavePeriod(val)} />
            ,
            <ActionSetting
                id='settings-protocol-clear'
                key='settings-protocol-clear'
                title='Очистить протокол'
                value='Очистить'
                disabled={ProtocolRecordsStore.state.inProcess}
                onClick={() => OtherSettingsStore.ShowClearAllProtocolModal()} />
            ,
            (ProtocolRecordsStore.state.inProcess
                ? (
                    <NamedBlock
                        key="settings-protocol-clear-process"
                        title='Архивация протокола'
                        className='common-info-named-block'>
                        <div className='total-sync-info'>
                            <div className='total-sync-info-title'>
                                <div>
                                    {`Архивировано ${ProtocolRecordsStore.state.clearProgress}%`}
                                </div>
                            </div>
                            <LoadingIndicator
                                loaded={ProtocolRecordsStore.state.clearProgress}
                                total={100}
                                runner={ProtocolRecordsStore.state.clearProgress === 0} />
                        </div>
                    </NamedBlock>
                )
                : "")
        ];

        var settingsFiles = ProductMode.FilterControls(
            AppStore.productModeSettings?.filterOtherSettingsSystemsSettingsBlockWebKeysVisible,
            settingsFilesForCheckVisibility
        );
        var settingsUsers = ProductMode.FilterControls(
            AppStore.productModeSettings?.filterOtherSettingsSystemsSettingsBlockWebKeysVisible,
            settingsUsersForCheckVisibility
        );
        var settingsProtocol = ProductMode.FilterControls(
            AppStore.productModeSettings?.filterOtherSettingsProtocolSettingsBlockWebKeysVisible,
            settingsProtocolForCheckVisibility
        );

        var settingsForCheckVisibility = [
            <SettingsBlock
                key="client-traces-settings-block"
                title='Хранение клиентских логов'>

                <ComboBoxSetting
                    id='client-logs-clean-period'
                    key='client-logs-clean-period'
                    title='Автоматически удалять клиентские логи через:'
                    values={OtherSettingsStore.clientLogsCleanPeriods}
                    selectedItem={OtherSettingsStore.currentLocalSettings.clientLogsCleanPeriod}
                    onSelectedItemChanged={key => OtherSettingsStore.SetClientLogsCleanPeriod(key)} />

            </SettingsBlock>
            /*
            ,
            <SettingsBlock
                key="device-connect-settings-block"
                title="Настройки подключения мобильных устройств">

                <TextInputSetting
                    id='external-smr-url'
                    key='external-smr-url'
                    title='Внешний адрес СМР:'
                    helperText='Введите внешний адрес СМР, он будет использован для генерации QR-кода (раздел "Пользователи", настройка устройств пользователя).'
                    value={OtherSettingsStore.currentLocalSettings.externalSmrUrl}
                    onChanged={(value) => OtherSettingsStore.SetExternalSmrUrl(value)}
                    textOptions={{ maxLength: 128 }} />

            </SettingsBlock>
            */
            ,
            <SettingsBlock
                key="files-settings-block"
                title="Файлы">

                {settingsFiles.map(it => it)}

            </SettingsBlock>
            ,
            <SettingsBlock
                key="protocol-settings-block"
                title='Протоколирование'>

                {settingsProtocol.map(it => it)}

            </SettingsBlock>
            ,
            <SettingsBlock
                key="support-settings-block"
                title='Техническая поддержка'>

                <TextInputSetting
                    key='support-email'
                    title='Адрес техподдержки:'
                    helperText='Формат адреса электронной почты: username@site(.domain). При указании нескольких адресов их следует разделять запятой (,).'
                    value={OtherSettingsStore.currentLocalSettings.supportEmail}
                    invalid={OtherSettingsStore.settingsErrors.supportEmailError}
                    onChanged={(value) => OtherSettingsStore.SetSupportEmail(value)}
                    textOptions={{ maxLength: 50, type: 'email', multiple: true }} />

            </SettingsBlock>
            ,
            <SettingsBlock
                key="users-settings-block"
                title='Пользователи'>

                {settingsUsers.map(it => it)}

            </SettingsBlock>
            ,
            <SettingsBlock
                key="email-informing-settings-block"
                title='E-mail информирование'>

                <SwitcherSetting
                    key='email-informing-protocol'
                    title='Информировать об ошибках в разделе "Протоколирование":'
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.protocol}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('protocol', value)} />

                <SwitcherSetting
                    key='email-informing-stoplist'
                    title='Информировать об ошибках в разделе "Стоп-лист":'
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.stoplist}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('stoplist', value)} />

                <TextInputSetting
                    id='informing-from'
                    key='email-informing-from'
                    title='E-mail отправителя:'
                    helperText='Необходимо указать e-mail адрес отправителя (например: sender@smr.loc).'
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.from}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('from', value)}
                    invalid={OtherSettingsStore.settingsErrors.emailInformingError}
                    textOptions={{ maxLength: 128, type: 'email', multiple: false }} />

                <TextInputSetting
                    id='informing-email'
                    key='email-informing-email'
                    title='E-mail получателя(ей):'
                    helperText='Через запятую в поле можно указать несколько E-mail адресов.'
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.email}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('email', value)}
                    invalid={OtherSettingsStore.settingsErrors.emailInformingFromError}
                    textOptions={{ type: 'email', multiple: true }} />

                <TextInputSetting
                    id='informing-smtpserver'
                    key='informing-smtpserver'
                    title='Адрес сервера SMTP:'
                    helperText='Необходимо указать адрес для соединения с сервером SMTP. Например: "your.mailserver.ru".'
                    short={true}
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.smtpServer}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('smtpServer', value)}
                    textOptions={{ maxLength: 128 }} />

                <TextInputSetting
                    id='informing-smtpport'
                    key='informing-smtpport'
                    title='Порт сервера SMTP:'
                    short={true}
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.smtpPort}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('smtpPort', value)}
                    textOptions={{ maxLength: 5 }} />

                <TextInputSetting
                    id='informing-login'
                    key='informing-login'
                    title='Имя пользователя SMTP:'
                    helperText='Введите имя только в том случае, если сервер SMTP требует этого.'
                    short={true}
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.login}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('login', value)}
                    textOptions={{ maxLength: 128, autoComplete: 'off' }} />

                <TextInputSetting
                    id='informing-password'
                    key='informing-password'
                    title='Пароль пользователя SMTP:'
                    helperText='Введите пароль, только если сервер SMTP требует этого. Внимание: этот пароль будет сохранен в базе данных в незашифрованном виде и будет виден всем, кто имеет доступ к ней или к этой странице настроек.'
                    short={true}
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.password}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('password', value)}
                    textOptions={{ maxLength: 128, autoComplete: 'new-password', type: "password" }} />

                <SwitcherSetting
                    key='email-informing-revocation'
                    title='Проверка на отозванный сертификат SSL:'
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.checkRevocation}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('checkRevocation', value)} />

                <TextInputSetting
                    id='informing-note'
                    key='informing-note'
                    title='Примечание:'
                    helperText='В данном поле вы можете указать дополнительную информацию для шаблона письма. Например, можно указать наименование организации.'
                    short={true}
                    value={OtherSettingsStore.currentLocalSettings.emailInforming.note}
                    onChanged={(value) => OtherSettingsStore.SetInformingValue('note', value)}
                    textOptions={{ maxLength: 128 }} />

                <ActionSetting
                    id='email-informing-sendtest'
                    key='email-informing-sendtest'
                    title='Отправить тестовое письмо'
                    value='Отправить'
                    onClick={() => OtherSettingsStore.SendTestEmail()} />

            </SettingsBlock>
            ,
            <SettingsBlock
                key="authentication-settings-block"
                title='Аутентификация'>

                <NumericSetting
                    id="session-idle-timeout"
                    key="session-idle-timeout"
                    title='Продолжительность сессии пользователя (минут):'
                    minValue={5}
                    maxValue={480}
                    value={OtherSettingsStore.currentLocalSettings.webSessionIdleTimeoutMinutes}
                    valueChanged={(val) => OtherSettingsStore.SetWebSessionIdleTimeoutMinutes(val)} />

                <NumericSetting
                    id="max-login-attempts"
                    key="max-login-attempts"
                    title='Число попыток входа в систему для администратора СМР:'
                    helperText='Число попыток входа в систему для пользователей с ролью технолог и помощник ограничиваются настройками СЭД'
                    minValue={1}
                    maxValue={99}
                    value={OtherSettingsStore.currentLocalSettings.adminMaxLoginAttempts}
                    valueChanged={(val) => OtherSettingsStore.SetAdminMaxLoginAttempts(val)} />

            </SettingsBlock>
        ];

        var settings = ProductMode.FilterControls(
            AppStore.productModeSettings?.filterOtherSettingsWebKeysVisible,
            settingsForCheckVisibility
        );

        return (
            <div className='other-settings'>
                <TransitionBlocker
                    blocked={OtherSettingsStore.GetSettingsChanged()}
                />

                <div className='other-settings-settings-container overflowing-element'>

                    {settings}

                </div>
                <div className='settings-buttons-container'>
                    <button className="blue-button"
                        onClick={_ => OtherSettingsStore.SaveSettingsWithBlock()}>Сохранить</button>
                </div>
                {OtherSettingsStore.settingsLoading ? <LoadView modal={true} /> : ''}
            </div>
        )
    }
}

export default observer(OtherSettings);